import {
  downloadFileAPI,
  uploadAPI,
  uploadMultipleAPI,
} from "api/fileManagerApi";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selAuthTokens } from "store/slices";
import { toast } from "react-toastify";
/* -------------------------------------------------------------------------- */
const initFileData = { file: null, url: "", fileId: "" };
const initMultipleFileData = [];
/* -------------------------------------------------------------------------- */
const acceptTypes = {
  image: "image/gif, image/jpeg, image/png",
  pdf: "application/pdf",
};

export const useFileManager = (props) => {
  const [acceptType, setAcceptType] = useState(null);
  const [fileData, setFileData] = useState(initFileData);
  const [arrayFileData, setArrayFileData] = useState(initMultipleFileData);
  const { token: Authorization } = useSelector(selAuthTokens);
  const inputRef = useRef(null);
  useEffect(() => {
    if (acceptType && inputRef?.current) {
      inputRef.current.click();
    }
  }, [acceptType]);

  function onFileChange(event) {
    let file = event.target?.files[0];
    let url = URL.createObjectURL(file);
    setFileData((prevState) => ({ ...prevState, file, url }));
  }
  function onFilesChange(event) {
    let files = [];
    for (const file of Array.from(event.target?.files)) {
      const plain = { file, url: URL.createObjectURL(file) };
      files.push(plain);
    }
    setArrayFileData((prev) => [...prev, ...files]);
    event.target.value = "";
  }
  const openFileManager = (type = "image") => {
    if (!inputRef?.current) return;
    if (acceptType === type) return inputRef.current?.click();
    setAcceptType(type);
  };

  const onClearFile = () => {
    setFileData(initFileData);
  };
  const onClearMultipleFile = () => {
    setArrayFileData(initMultipleFileData);
  };

  const onRemoveFile = (url) => {
    let filteredFiles = arrayFileData.filter((f) => f.url !== url);
    setArrayFileData(filteredFiles);
  };

  const onUpload = async () => {
    let { file } = fileData;
    if (file) {
      try {
        let res = await uploadAPI(file);
        if (res.message.id) {
          return res.message;
        }
        throw res.message;
      } catch (error) {}
    }
  };
  const onMultipleUpload = async (is_public = true, is_airline_public) => {
    let files = arrayFileData.map((f) => f?.file).filter(Boolean);
    if (!files.length) return { message: [] };

    try {
      let res = await uploadMultipleAPI(
        files,
        () => {},
        is_public,
        is_airline_public
      );
      if (res?.message?.length > 0) {
        return res;
      }
      throw new Error("File upload failed");
    } catch (error) {
      toast.error(error?.message || "File upload failed");
      throw error;
    }
  };

  const onFetchFile = async (fileId) => {
    try {
      let res = await downloadFileAPI(fileId, false, { Authorization });
      let url = URL.createObjectURL(res);
      return url;
    } catch (error) {
      let errors = {
        403: "Download Permission Denied!",
      };
      toast.error(errors[error?.errorCode] || "Download Failed!");
      return null;
    }
  };
  const onDownload = async (fileId) => {
    try {
      let res = await downloadFileAPI(fileId);
      let url = URL.createObjectURL(res);
      window.open(url, "_blank");
      return url;
    } catch (error) {
      let errors = {
        403: "Download Permission Denied!",
      };
      toast.error(errors[error?.errorCode] || "Download Failed!");
      return null;
    }
  };
  const FileManager = ({ children, multiple = false }) => {
    return (
      <>
        <input
          accept={acceptTypes[acceptType]}
          type="file"
          onChange={multiple ? onFilesChange : onFileChange}
          autoFocus
          style={{ display: "none" }}
          ref={inputRef}
          multiple={multiple}
        />
        {children}
      </>
    );
  };

  return {
    FileManager,
    fileData,
    filesData: arrayFileData,
    onClearFile,
    openFileManager,
    onUpload,
    onDownload,
    onFetchFile,
    onFileChange,
    onFilesChange,
    onMultipleUpload,
    onClearMultipleFile,
    onRemoveFile,
  };
};
